var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner-top',{attrs:{"title":"","show-icon-right":false}}),_c('div',{staticClass:"errorRecovery"},[_c('div',{staticClass:"weixin_code"},[_c('img',{attrs:{"src":_vm.codeImg}})]),_c('div',{staticClass:"back_answer",on:{"click":_vm.backAnswer}},[_vm._v("返回答案核对")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }